import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const ManageParticipantsSessionAndEventsTabWrapper = styled.div`
  .session-events-timeline {
    background-color: ${COLORS.cirrus_white};

    .MuiGrid2-container {
      padding: 0 8px 24px 24px;
      margin-top: 0;

      ${responsive.MOBILE`
        padding: 16px 8px 16px 8px;
      `}
    }

    .filter-wrapper {
      border-bottom: 1px solid ${COLORS.cirrus_black4};
    }
  }
`;
